import { defineComponent as C, ref as E, computed as h, h as p, Transition as W, mergeProps as F, unref as b } from "vue";
function y(t) {
  return {
    height: t.style.height,
    width: t.style.width,
    position: t.style.position,
    visibility: t.style.visibility,
    overflow: t.style.overflow,
    paddingTop: t.style.paddingTop,
    paddingBottom: t.style.paddingBottom,
    borderTopWidth: t.style.borderTopWidth,
    borderBottomWidth: t.style.borderBottomWidth,
    marginTop: t.style.marginTop,
    marginBottom: t.style.marginBottom
  };
}
function L(t, o, e) {
  const n = b(t), { width: i } = getComputedStyle(o);
  o.style.width = i, o.style.position = "absolute", o.style.visibility = "hidden", o.style.height = "";
  const { height: a } = getComputedStyle(o);
  return o.style.width = e.width, o.style.position = e.position, o.style.visibility = e.visibility, o.style.height = n, o.style.overflow = "hidden", e.height && e.height != n ? e.height : a;
}
function f(t, o, e, n, i) {
  const a = t.animate(n, i);
  t.style.height = o.height, a.onfinish = () => {
    t.style.overflow = o.overflow, e();
  };
}
function m(t, o, e, n) {
  const i = b(o);
  return [
    {
      height: i,
      opacity: t.opacityClosed,
      paddingTop: i,
      paddingBottom: i,
      borderTopWidth: i,
      borderBottomWidth: i,
      marginTop: i,
      marginBottom: i
    },
    {
      height: e,
      opacity: t.opacityOpen,
      paddingTop: n.paddingTop || 0,
      paddingBottom: n.paddingBottom || 0,
      borderTopWidth: n.borderTopWidth || 0,
      borderBottomWidth: n.borderBottomWidth || 0,
      marginTop: n.marginTop || 0,
      marginBottom: n.marginBottom || 0
    }
  ];
}
const V = C({
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    /**
     * Time in milliseconds for the slide duration
     */
    duration: {
      type: Number,
      default: 500
    },
    /**
     * Timing function for the animation
     */
    timingFunction: {
      type: String,
      default: "ease-in-out"
    },
    /**
     * Independent timing function for the animation when entering
     */
    timingFunctionEnter: {
      type: String,
      default: null
    },
    /**
     * Independent timing function for the animation when leaving
     */
    timingFunctionLeave: {
      type: String,
      default: null
    },
    /**
     * Opacity value from 0 - 1 of the element when open
     */
    opacityOpen: {
      type: Number,
      default: 1
    },
    /**
     * Opacity value from 0 - 1 of the element when closed
     */
    opacityClosed: {
      type: Number,
      default: 0
    },
    /**
     * HTML tag to use for the outer container
     */
    tag: {
      type: String,
      default: "div"
    }
  },
  emits: ["update:modelValue", "open-start", "open-end", "close-start", "close-end"],
  setup(t, { slots: o, attrs: e, emit: n }) {
    const i = E("0px"), a = h(() => t.timingFunctionEnter || t.timingFunction), v = h(() => t.timingFunctionLeave || t.timingFunction);
    function T(g, c) {
      const d = g, s = y(d), r = L(i, d, s), u = m(t, i, r, s), l = { duration: t.duration, easing: a.value };
      f(d, s, () => {
        c(), n("open-end");
      }, u, l);
    }
    function B(g, c) {
      const d = g, s = y(d), { height: r } = getComputedStyle(d);
      d.style.height = r, d.style.overflow = "hidden";
      const u = m(t, i, r, s).reverse(), l = { duration: t.duration, easing: v.value };
      f(d, s, () => {
        c(), n("close-end");
      }, u, l);
    }
    return () => p(
      W,
      {
        css: !1,
        onBeforeEnter: () => n("open-start"),
        onEnter: T,
        onBeforeLeave: () => n("close-start"),
        onLeave: B
      },
      {
        default: () => t.modelValue ? p(
          t.tag,
          F(e, {
            class: "slide-up-down__container"
          }),
          o
        ) : null
      }
    );
  }
});
export {
  V as Vue3SlideUpDown
};
